export const CANCELED_ORDER_NEXT_ORDER_DATE = 'N/A';

export const FREQUENCY_INTERVAL_LIST_IN_STRING = '15,30,45,60,90';
